import dynamic from "next/dynamic";
import PricesAndFeaturesCardsPricingConfig from "./prices-and-features-cards-pricing-config";
import PricesAndFeaturesCardsPricingAdvancedConfig from "./prices-and-features-cards-pricing-advanced-config";
const PricesAndFeaturesCardsPricingComponent = dynamic(()=>import("./prices-and-features-cards-pricing-component"));
export default {
    PricesAndFeaturesCardsPricingComponent,
    PricesAndFeaturesCardsPricingConfig,
    PricesAndFeaturesCardsPricingAdvancedConfig
};
